import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './contexts/UserContext';
import { PyodideProvider } from './contexts/PyodideContext';

// ✅ Create root container
const root = ReactDOM.createRoot(document.getElementById('root'));

// ✅ Wrap App with both providers
root.render(
  <React.StrictMode>
    <UserProvider>
      <PyodideProvider>
        <App />
      </PyodideProvider>
    </UserProvider>
  </React.StrictMode>
);

// Optional: Performance measuring
reportWebVitals();
